import { global_hooks } from 'src/globals';

global_hooks.on('init', init);
function init() {
	if (document.querySelector('.ff_swiper')) {
		import('./carousel');
	}
}
